import actions from './actions';
import staticData from '../../demoData/projectData.json';

const {
  LOADING,
  SINGLE_PROJECT_BEGIN,
  SINGLE_PROJECT_SUCCESS,
  SINGLE_PROJECT_ERR,

  FILTER_PROJECT_BEGIN,
  FILTER_PROJECT_SUCCESS,
  FILTER_PROJECT_ERR,

  SORTING_PROJECT_BEGIN,
  SORTING_PROJECT_SUCCESS,
  SORTING_PROJECT_ERR,

  ASANA_ACCESS_TOKEN,
  TRELLO_ACCESS_TOKEN,
  ELASTICSEARCH_ACCESS_TOKEN,
  AIRTABLE_ACCESS_TOKEN,
  SURVEY_MONKEY_ACCESS_TOKEN,
  EVENTBRITE_ACCESS_TOKEN,
  SPOTIFY_ACCESS_TOKEN,
  ADOBE_ACCESS_TOKEN,
} = actions;

const initialStateFilter = {
  data: staticData,
  asana_access_token: {},
  trello_access_token: {},
  elasticsearch_access_token: {},
  airtable_access_token: {},
  surveymonkey_access_token: {},
  eventbrite_access_token: {},
  spotify_access_token: {},
  adobe_access_token: {},
  loading: false,
  error: null,
};

const projectReducer = (state = initialStateFilter, action) => {
  const { type, data, err } = action;
  switch (type) {
    case LOADING:
      return {
        ...state,
        loading: !state.loading,
      };
    case FILTER_PROJECT_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case FILTER_PROJECT_SUCCESS:
      return {
        ...initialStateFilter,
        data,
        loading: false,
      };
    case FILTER_PROJECT_ERR:
      return {
        ...initialStateFilter,
        error: err,
        loading: false,
      };
    case SORTING_PROJECT_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case SORTING_PROJECT_SUCCESS:
      return {
        ...initialStateFilter,
        data,
        loading: false,
      };
    case SORTING_PROJECT_ERR:
      return {
        ...initialStateFilter,
        error: err,
        loading: false,
      };
    case ASANA_ACCESS_TOKEN:
      return {
        ...state,
        asana_access_token: data,
      };
    case TRELLO_ACCESS_TOKEN:
      return {
        ...state,
        trello_access_token: data,
      };
    case ELASTICSEARCH_ACCESS_TOKEN:
      return {
        ...state,
        elasticsearch_access_token: data,
      };
    case AIRTABLE_ACCESS_TOKEN:
      return {
        ...state,
        airtable_access_token: data,
      };
    case SURVEY_MONKEY_ACCESS_TOKEN:
      return {
        ...state,
        surveymonkey_access_token: data,
      };
    case EVENTBRITE_ACCESS_TOKEN:
      return {
        ...state,
        eventbrite_access_token: data,
      };
    case SPOTIFY_ACCESS_TOKEN:
      return {
        ...state,
        spotify_access_token: data,
      };
    case ADOBE_ACCESS_TOKEN:
      return {
        ...state,
        adobe_access_token: data,
      };
    default:
      return state;
  }
};

const initialState = {
  data: staticData,
  loading: false,
  error: null,
};

const SingleProjectReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case SINGLE_PROJECT_BEGIN:
      return {
        ...initialState,
        loading: true,
      };
    case SINGLE_PROJECT_SUCCESS:
      return {
        ...initialState,
        data,
        loading: false,
      };
    case SINGLE_PROJECT_ERR:
      return {
        ...initialState,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

export { SingleProjectReducer, projectReducer };
